// extracted by mini-css-extract-plugin
export default {"container":"style_container__zccZp","innerBox":"style_innerBox__kAX8Q","imageBox":"style_imageBox__TtD5V","description":"style_description__s2V-s","link":"style_link__jg08E"};